import { FunctionComponent } from 'react' ;

import { Stepper as MuiStepper, Step as MuiStep, StepLabel as MuiStepLabel, StepIconProps as MuiStepIconProps, Box } from '@mui/material';
import { IMenuItem } from '@luxon/interfaces';

interface IStepperProps {
    activeStepIndex: number;
    canNavigateBack?: boolean;
    activeStepChanged?: (newIndex: number) => void;
    steps: IMenuItem[];
}
export const Stepper: FunctionComponent<IStepperProps> = (props: IStepperProps) => {

    const {
        activeStepIndex,
        canNavigateBack,
        activeStepChanged,
        steps
    } = props;

    const StepIcon = (step: IMenuItem, stepIndex: number, stepProps: MuiStepIconProps): JSX.Element => {
        return (
            <Box
                sx={{
                    height: 50,
                    width: 50,
                    color: 'var(--color-light)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '50%',
                    zIndex: 1,
                    cursor: canNavigateBack && stepProps.completed ? 'pointer' : 'default',
                    backgroundColor: stepProps.active || stepProps.completed ? 'var(--color-primary)' : 'var(--color-lightGrey)'
                }}
                onClick={() => {
                    if (canNavigateBack && stepProps.completed && activeStepChanged) {
                        activeStepChanged(stepIndex);
                    }
                }}
            >
                {step.icon}
            </Box>
        )
    };

    return (
        <MuiStepper alternativeLabel activeStep={activeStepIndex} sx={{marginBottom: '30px'}}>
            {
                steps.map((step, index) => (
                    <MuiStep key={step.text}>
                        <MuiStepLabel
                            StepIconComponent={(props) => StepIcon(step, index, props)}
                        >
                            {step.text}
                        </MuiStepLabel>
                    </MuiStep>
                ))
            }
        </MuiStepper>
    )
};